import styled, { css } from 'styled-components';
import { theme } from 'modules/tetrisTheme';
import { responsiveProperty } from 'modules/utils/responsiveProperty';
export const typographyBase = css `
  font-family: ${theme.fontFamily.default};
`;
export const truncate = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const typographyDefaults = {
    $fontSize: 'medium',
    $fontWeight: 'regular',
    $fontStyle: 'normal',
    $lineHeight: 'default',
};
function getColor(props) {
    const { $appearance, $color } = props;
    if ($appearance) {
        return responsiveProperty('color', `semantic.text.${$appearance}`);
    }
    if ($color) {
        return responsiveProperty('color', $color);
    }
    return theme.semantic.text[200];
}
export const Typography = styled.span.attrs((props) => (Object.assign(Object.assign({}, typographyDefaults), props))) `
  ${typographyBase};
  ${({ $fontSize }) => $fontSize && responsiveProperty('fontSize', $fontSize)};
  ${({ $fontWeight }) => $fontWeight && responsiveProperty('fontWeight', $fontWeight)};
  ${({ $fontStyle }) => $fontStyle && responsiveProperty('fontStyle', $fontStyle)};
  ${({ $lineHeight }) => $lineHeight && responsiveProperty('lineHeight', $lineHeight)};

  ${getColor};

  ${(props) => props.$truncate && truncate};
`;
const headingsBase = css `
  ${typographyBase};
  margin: 0;
  color: ${theme.semantic.foreground.primary};
`;
export const H1 = styled.h1 `
  ${headingsBase};

  font: ${theme.fontRole.display};
  letter-spacing: -0.015em;

  ${(props) => props.$truncate && truncate};
`;
export const H2 = styled.h2 `
  ${headingsBase};

  font: ${theme.fontRole.heading};
  letter-spacing: -0.01em;

  ${(props) => props.$truncate && truncate};
`;
export const H3 = styled.h3 `
  ${headingsBase};

  font: ${theme.fontRole.title};
  font-weight: ${theme.fontWeight.semibold};

  ${(props) => props.$truncate && truncate};
`;
export const H4 = styled.h4 `
  ${headingsBase};

  font: ${theme.fontRole.bodyEm};
  font-weight: ${theme.fontWeight.semibold};

  ${(props) => props.$truncate && truncate};
`;
export const H5 = styled.h5 `
  ${headingsBase};

  font-size: 1.25rem;
  font-weight: ${theme.fontWeight.regular};
  line-height: 1.75rem;

  ${(props) => props.$truncate && truncate};
`;
export const H6 = styled.h6 `
  ${headingsBase};

  font-size: 1rem;
  font-weight: ${theme.fontWeight.regular};
  line-height: 1.375rem;

  ${(props) => props.$truncate && truncate};
`;
